<template>
	<div class="conten" style="padding: 0;">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">				
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="goodsTypeName" label="分类名称" align="center">
				</el-table-column>
				<el-table-column prop="goodsTypeLabel" label="分类标签" align="center">
				</el-table-column>
				<el-table-column prop="goodsTypeSort" label="排序" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="level(scope.row)">查看二级</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="分类名称" label-width='100px'>
					<el-input v-model="form.goodsTypeName" maxlength="18" autocomplete="off" placeholder="请输入分类名称"></el-input>
				</el-form-item>	
					<el-form-item label="分类标签" label-width='100px'>
						<el-input v-model="form.goodsTypeLabel" maxlength="18" autocomplete="off" placeholder="请输入分类标签"></el-input>
				</el-form-item>
				<el-form-item label="分类排序" label-width='100px'>
					<el-input v-model.number="form.goodsTypeSort" maxlength="10" autocomplete="off" placeholder="请输入分类排序">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog custom-class="level" :close-on-click-modal='false' :close-on-press-escape='false'  title="二级分类" :visible.sync="levelDialogVisible" :modal-append-to-body='false'  width="80%">
			
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true">
					<el-form-item>
						<el-button type="primary" @click='levelAdd'>新增</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<div>
				<el-table :data="levelTableData" style="width: 100%" border>
					<el-table-column prop="goodsTypeName" label="分类名称" align="center">
					</el-table-column>
					<el-table-column prop="goodsTypeSort" label="排序" align="center">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="250" align="center">
						<template slot-scope="scope">
							<el-button size="mini" @click="levelEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" @click="levelDel(scope.row)">删除</el-button>
							<el-button size="mini" type="warning" @click="tertiary(scope.row)">查看三级</el-button>	
						</template>
					</el-table-column>
				</el-table>
			</div>
			
			
		</el-dialog>
		
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="levelIsAdd?'新增':'修改'" :visible.sync="levelDialogVisibleBox" :modal-append-to-body='false' width="600px">
			<el-form :model="levelForm">
				<el-form-item label="父级名称" label-width='100px'>
					<el-input v-model="levelForm.parentName" disabled maxlength="18" autocomplete="off" placeholder=""></el-input>
				</el-form-item>	
					
					<el-form-item label="父级ID" label-width='100px'>
						<el-input v-model="levelForm.parentId" disabled maxlength="18" autocomplete="off" placeholder=""></el-input>
				</el-form-item>		
				<el-form-item label="分类名称" label-width='100px'>
					<el-input v-model="levelForm.goodsTypeName" maxlength="18" autocomplete="off" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="分类排序" label-width='100px'>
					<el-input v-model.number="levelForm.goodsTypeSort" maxlength="10" autocomplete="off" placeholder="请输入分类排序">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="levelDialogVisibleBox = false">取 消</el-button>
				<el-button type="primary" @click="levelSub">确 定</el-button>
			</div>
		</el-dialog>

<el-dialog custom-class="level" :close-on-click-modal='false' :close-on-press-escape='false'  title="三级分类" :visible.sync="tertiaryDialogVisible" :modal-append-to-body='false'  width="60%">
			
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true">
					<el-form-item>
						<el-button type="primary" @click='tertiaryAdd'>新增</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<div>
				<el-table :data="tertiaryTableData" style="width: 100%" border>
					<el-table-column prop="goodsTypeName" label="分类名称" align="center">
					</el-table-column>
					<el-table-column prop="goodsTypeSort" label="排序" align="center">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="250" align="center">
						<template slot-scope="scope">
							<el-button size="mini" @click="tertiaryEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger" @click="tertiaryDel(scope.row)">删除</el-button>
						<!-- 	<el-button size="mini" type="warning" @click="tertiary(scope.row)">查看三级</el-button>	 -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			
			
		</el-dialog>
		
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="tertiaryIsAdd?'新增':'修改'" :visible.sync="tertiaryDialogVisibleBox" :modal-append-to-body='false' width="600px">
			<el-form :model="tertiaryForm">
				<el-form-item label="父级名称" label-width='100px'>
					<el-input v-model="tertiaryForm.parentName" disabled maxlength="18" autocomplete="off" placeholder=""></el-input>
				</el-form-item>	
					
					<el-form-item label="父级ID" label-width='100px'>
						<el-input v-model="tertiaryForm.parentId" disabled maxlength="18" autocomplete="off" placeholder=""></el-input>
				</el-form-item>		
				<el-form-item label="分类名称" label-width='100px'>
					<el-input v-model="tertiaryForm.goodsTypeName" maxlength="18" autocomplete="off" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="分类排序" label-width='100px'>
					<el-input v-model.number="tertiaryForm.goodsTypeSort" maxlength="10" autocomplete="off" placeholder="请输入分类排序">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="tertiaryDialogVisibleBox = false">取 消</el-button>
				<el-button type="primary" @click="tertiarySub">确 定</el-button>
			</div>
		</el-dialog>



	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				dialogVisible: false,				
				isAdd: true,
				form: {
					"goodsTypeId": '',
					"goodsTypeLevel": 1,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": '',
					"parentName": '',
					goodsTypeLabel:""
				},
				
				levelDialogVisible: false,
				levelDialogVisibleBox: false,
				levelIsAdd: true,
				goodsTypeId:'',
				goodsTypeName:"",
				goodsTypeId1:'',
				goodsTypeName1:"",
				levelTableData:[],
				levelForm : {
					"goodsTypeId": '',
					"goodsTypeLevel": 2,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": this.goodsTypeId,
					"parentName": this.goodsTypeName
				},
				tertiaryDialogVisible: false,
				tertiaryDialogVisibleBox: false,
				tertiaryIsAdd: true,
				tertiaryTableData:[],
				tertiaryForm  : {
					"goodsTypeId": '',
					"goodsTypeLevel": 3,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": this.goodsTypeId,
					"parentName": this.goodsTypeName
				},
			}
		},
		created() {
			this.getGoodsType()
		},
		methods: {
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form = {
					"goodsTypeId": '',
					"goodsTypeLevel": 1,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": '',
					"parentName": ''
				}
			},
			//提交
			sub() {
				if (this.form.goodsTypeName.length == 0) {
					this.$message('请输入分类名称');
					return false
				}
				if (!this.isNullNum(this.form.goodsTypeSort)) {
					this.$message('排序请输入为数字');
					return false
				}

				var url = this.isAdd ? "/goodsType/add" : "/goodsType/update"
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getGoodsType()
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getGoodsType()
						}
					})
				}

			},

			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goodsType/del?" + this.$qs.stringify({
						goodsTypeId: row.goodsTypeId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getGoodsType()
						}
					})
				}).catch(() => {});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form = JSON.parse(JSON.stringify(row))
				// this.form.password=''

			},
			//列表数据
			getGoodsType() {
				this.httpPost("/goodsType/allFirstGoodsType").then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tableData = res.data
					}
				})
			},
						
			//查看二级
			level(row){
				this.levelTableData=[]
				this.goodsTypeId=row.goodsTypeId
				this.goodsTypeName=row.goodsTypeName
				this.levelDialogVisible=true
				this.getleveGoodsType()
			},
			//二级列表数据
			getleveGoodsType() {
				this.httpPost("/goodsType/getGoodsTypeByParentId?"+this.$qs.stringify({
						goodsTypeId: this.goodsTypeId
					})).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.levelTableData = res.data
					}
				})
			},
			
			//二级新增
			levelAdd() {
				this.levelDialogVisibleBox = true
				this.levelIsAdd = true
				this.levelForm = {
					"goodsTypeId": '',
					"goodsTypeLevel": 2,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": this.goodsTypeId,
					"parentName": this.goodsTypeName
				}
			},
			//二级提交
			levelSub() {
				if (this.levelForm.goodsTypeName.length == 0) {
					this.$message('请输入分类名称');
					return false
				}
				if (!this.isNullNum(this.levelForm.goodsTypeSort)) {
					this.$message('排序请输入为数字');
					return false
				}
			
				var url = this.levelIsAdd ? "/goodsType/add" : "/goodsType/update"
				if (this.levelIsAdd) {
					this.httpPost(url, this.levelForm, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.levelDialogVisibleBox = false
							this.getleveGoodsType()
						}
					})
				} else {
					this.httpPut(url, this.levelForm, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.levelDialogVisibleBox = false
							this.getleveGoodsType()
						}
					})
				}
			
			},
			
			//二级删除
			levelDel(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goodsType/del?" + this.$qs.stringify({
						goodsTypeId: row.goodsTypeId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getleveGoodsType()
						}
					})
				}).catch(() => {});
			},
			//二级修改
			levelEdit(row) {
				console.log(row);
				this.levelDialogVisibleBox = true
				this.levelIsAdd = false
				this.levelForm = JSON.parse(JSON.stringify(row))
				this.levelForm.parentId=this.goodsTypeId
				this.levelForm.parentName= this.goodsTypeName			
			},
			
			//三级列表数据
			gettertiaryGoodsType() {
				this.httpPost("/goodsType/getGoodsTypeByParentId?"+this.$qs.stringify({
						goodsTypeId: this.goodsTypeId1
					})).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tertiaryTableData = res.data
					}
				})
			},
			
			//查看三级
			tertiary(row){
				this.tertiaryTableData=[]
				this.goodsTypeId1=row.goodsTypeId
				this.goodsTypeName1=row.goodsTypeName
				this.tertiaryDialogVisible=true
				this.gettertiaryGoodsType()
			},
			//三级新增
			tertiaryAdd() {
				this.tertiaryDialogVisibleBox = true
				this.tertiaryIsAdd = true
				this.tertiaryForm = {
					"goodsTypeId": '',
					"goodsTypeLevel": 3,
					"goodsTypeName": "",
					"goodsTypeSort": '',
					"parentId": this.goodsTypeId1,
					"parentName": this.goodsTypeName1
				}
			},
			//三级提交
			tertiarySub() {
				if (this.tertiaryForm.goodsTypeName.length == 0) {
					this.$message('请输入分类名称');
					return false
				}
				if (!this.isNullNum(this.tertiaryForm.goodsTypeSort)) {
					this.$message('排序请输入为数字');
					return false
				}
			
				var url = this.levelIsAdd ? "/goodsType/add" : "/goodsType/update"
				if (this.levelIsAdd) {
					this.httpPost(url, this.tertiaryForm, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.tertiaryDialogVisibleBox = false
							this.gettertiaryGoodsType()
						}
					})
				} else {
					this.httpPut(url, this.tertiaryForm, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.tertiaryDialogVisibleBox = false
							this.gettertiaryGoodsType()
						}
					})
				}
			
			},
			
			//三级删除
			tertiaryDel(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goodsType/del?" + this.$qs.stringify({
						goodsTypeId: row.goodsTypeId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.gettertiaryGoodsType()
						}
					})
				}).catch(() => {});
			},
			//三级修改
			tertiaryEdit(row) {
				console.log(row);
				this.tertiaryDialogVisibleBox = true
				this.tertiaryIsAdd = false
				this.tertiaryForm = JSON.parse(JSON.stringify(row))
						this.tertiaryForm.parentId= this.goodsTypeId1
						this.tertiaryForm.parentName= this.goodsTypeName1
			},
			
			
		},


	}
</script>

<style scoped lang='scss'>
	::v-deep .el-dialog__body{
		padding-top: 0;
	}
	
	::v-deep .level {
	    margin: 4% auto auto auto !important;
	    max-height: 80vh;
		min-height: 80vh;
		overflow-y: auto;		
	  }
</style>
